export const gtmAddToBasketEvent = (productName: string) => ({
  event: 'Getty_Productpage_Add_to_basket',
  eventLabel: `Add to basket GettyImage-${productName}`,
});

export default gtmAddToBasketEvent;
